'use client';
import { useState, useEffect } from 'react';
import { climbService } from './supabaseService';
import { type Climb } from './climbData';

export function usePersistedClimbs(): Climb[] {
  const [climbs, setClimbs] = useState<Climb[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    climbService.getAll().then((data) => {
      // Always use Supabase data — never fall back to hardcoded list
      setClimbs(data ?? []);
      setLoaded(true);
    }).catch(() => {
      setLoaded(true);
    });
  }, []);

  return climbs;
}
